import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Box, Center, Spinner, Text, VStack } from '@chakra-ui/react';
import { ADVISORS_ORDER_BY_LAST_ACTIVITY } from '@src/components/sco/Advisors/constants';
import { filterEngagements, useAdvisorBoard } from '@src/components/sco/Advisors/hooks/useAdvisorBoard';
import { EngagementAsidePanel } from '@src/components/sco/Advisors/layout/EngagementAsidePanel';
import { LockedTeamAdvisorMiniProfile } from '@src/components/sco/Advisors/layout/LockedTeamAdvisorMiniProfile';
import { findLockedTeamAdvisor } from '@src/components/sco/Advisors/model/access';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { AdvisorsQueryState } from '@src/components/sco/Advisors/shared/AdvisorsQueryState';
import { normalizeAsPath } from '@src/components/sco/Advisors/utils';
import { engagementDisplayName, isEngagementChatActive } from '@src/components/sco/Advisors/utils/mapEngagements';
import { findFounderEngagement, founderDisplayName, founderUserIdOf, isActiveFounderEngagement } from '@src/components/sco/Advisors/utils/mapFounderEngagements';
import { ADVISOR_ENGAGEMENT_STATUS_ACTIVE } from '@src/constants/advisor-engagement-statuses';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import { ADVISOR_FOUNDER_ENGAGEMENTS } from '@src/gql/queries/AdvisorFounderEngagements';
import { ScoAdvisorEngagement } from '@src/graphql-types';
import { useRouter } from 'next/router';
import { useEffect, useMemo } from 'react';
type FounderEngagementsResult = {
  advisorEngagements?: {
    items?: Array<ScoAdvisorEngagement | null> | null;
  } | null;
};
export const AdvisorChatAside = () => {
  const $ = _c(66);
  const paths = useAdvisorsPaths();
  const router = useRouter();
  const activeContent = useActiveContentContext();
  const boardQuery = useAdvisorBoard();
  let isAskAdvisorsRoute;
  let isAskRoute;
  let path;
  let t0;
  if ($[0] !== paths.base || $[1] !== router.asPath) {
    path = normalizeAsPath(router.asPath);
    isAskRoute = path === `${paths.base}/ask` || path === paths.base;
    isAskAdvisorsRoute = path.startsWith(`${paths.base}/ask-advisors`);
    t0 = path.startsWith(`${paths.base}/my-founders`) && path !== `${paths.base}/my-founders/all`;
    $[0] = paths.base;
    $[1] = router.asPath;
    $[2] = isAskAdvisorsRoute;
    $[3] = isAskRoute;
    $[4] = path;
    $[5] = t0;
  } else {
    isAskAdvisorsRoute = $[2];
    isAskRoute = $[3];
    path = $[4];
    t0 = $[5];
  }
  const isMyFoundersRoute = t0;
  const isUpgradeRoute = path === `${paths.base}/upgrade`;
  const selectedAdvisorUserId = typeof router.query.advisorUserId === "string" ? router.query.advisorUserId : undefined;
  const selectedAdvisorKey = typeof router.query.advisorKey === "string" ? router.query.advisorKey : undefined;
  let t1;
  bb0: {
    const raw = router.query.founderUserId;
    if (typeof raw === "string" && raw) {
      t1 = raw;
      break bb0;
    }
    if (Array.isArray(raw) && typeof raw[0] === "string" && raw[0]) {
      t1 = raw[0];
      break bb0;
    }
    t1 = undefined;
  }
  const selectedFounderUserId = t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [ADVISOR_ENGAGEMENT_STATUS_ACTIVE];
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== selectedFounderUserId) {
    t3 = selectedFounderUserId ? [selectedFounderUserId] : undefined;
    $[7] = selectedFounderUserId;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = {
      statusKeys: t2,
      page: 1,
      pageSize: 1,
      orderBy: ADVISORS_ORDER_BY_LAST_ACTIVITY,
      founderUserIds: t3
    };
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = !isMyFoundersRoute || !selectedFounderUserId;
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = {
      variables: t4,
      skip: t5,
      fetchPolicy: "cache-and-network"
    };
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const founderQuery = useQuery(ADVISOR_FOUNDER_ENGAGEMENTS, t6);
  boardQuery.data?.advisorBoard;
  const t7 = boardQuery.data?.advisorBoard;
  let t8;
  if ($[14] !== t7) {
    t8 = filterEngagements(t7);
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const board = t8;
  let t9;
  if ($[16] !== founderQuery.data?.advisorEngagements?.items) {
    t9 = () => (founderQuery.data?.advisorEngagements?.items || []).filter(isActiveFounderEngagement) as ScoAdvisorEngagement[];
    $[16] = founderQuery.data?.advisorEngagements?.items;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  founderQuery.data?.advisorEngagements?.items;
  let t10;
  if ($[18] !== t9) {
    t10 = t9();
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const founderEngagements = t10;
  let t11;
  if ($[20] !== board) {
    t11 = board.filter(_temp);
    $[20] = board;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const humanAdvisors = t11;
  let t12;
  bb1: {
    if (!isUpgradeRoute) {
      t12 = null;
      break bb1;
    }
    let t13;
    if ($[22] !== selectedAdvisorKey || $[23] !== selectedAdvisorUserId) {
      t13 = findLockedTeamAdvisor({
        navKey: selectedAdvisorKey,
        userId: selectedAdvisorUserId
      });
      $[22] = selectedAdvisorKey;
      $[23] = selectedAdvisorUserId;
      $[24] = t13;
    } else {
      t13 = $[24];
    }
    t12 = t13;
  }
  const lockedTeamAdvisor = t12;
  let t13;
  bb2: {
    if (isMyFoundersRoute) {
      if (!selectedFounderUserId) {
        t13 = null;
        break bb2;
      }
      let t14;
      if ($[25] !== founderEngagements || $[26] !== selectedFounderUserId) {
        t14 = findFounderEngagement(founderEngagements, selectedFounderUserId) ?? founderEngagements[0] ?? null;
        $[25] = founderEngagements;
        $[26] = selectedFounderUserId;
        $[27] = t14;
      } else {
        t14 = $[27];
      }
      t13 = t14;
      break bb2;
    }
    if (isAskRoute) {
      let t14;
      if ($[28] !== board) {
        t14 = board.find(_temp2) ?? null;
        $[28] = board;
        $[29] = t14;
      } else {
        t14 = $[29];
      }
      t13 = t14;
      break bb2;
    }
    if (isAskAdvisorsRoute) {
      const targetUserId = selectedAdvisorUserId ?? humanAdvisors[0]?.advisorUser?.userId;
      let t14;
      if ($[30] !== humanAdvisors || $[31] !== targetUserId) {
        t14 = humanAdvisors.find(engagement_1 => engagement_1.advisorUser?.userId === targetUserId) ?? humanAdvisors[0] ?? null;
        $[30] = humanAdvisors;
        $[31] = targetUserId;
        $[32] = t14;
      } else {
        t14 = $[32];
      }
      t13 = t14;
      break bb2;
    }
    if (isUpgradeRoute) {
      if (selectedAdvisorUserId) {
        let t14;
        if ($[33] !== humanAdvisors || $[34] !== selectedAdvisorUserId) {
          let t15;
          if ($[36] !== selectedAdvisorUserId) {
            t15 = engagement_2 => engagement_2.advisorUser?.userId === selectedAdvisorUserId;
            $[36] = selectedAdvisorUserId;
            $[37] = t15;
          } else {
            t15 = $[37];
          }
          t14 = humanAdvisors.find(t15);
          $[33] = humanAdvisors;
          $[34] = selectedAdvisorUserId;
          $[35] = t14;
        } else {
          t14 = $[35];
        }
        const match = t14;
        if (match) {
          t13 = match;
          break bb2;
        }
      }
      t13 = null;
      break bb2;
    }
    let t14;
    if ($[38] !== board || $[39] !== router.asPath || $[40] !== selectedAdvisorUserId) {
      t14 = board.find(engagement_3 => isEngagementChatActive(engagement_3, router.asPath, selectedAdvisorUserId)) ?? null;
      $[38] = board;
      $[39] = router.asPath;
      $[40] = selectedAdvisorUserId;
      $[41] = t14;
    } else {
      t14 = $[41];
    }
    t13 = t14;
  }
  const activeEngagement = t13;
  let t14;
  if ($[42] !== activeEngagement || $[43] !== isMyFoundersRoute || $[44] !== lockedTeamAdvisor) {
    t14 = isMyFoundersRoute ? activeEngagement ? founderDisplayName(activeEngagement) : "Founder" : activeEngagement ? engagementDisplayName(activeEngagement) : lockedTeamAdvisor ? lockedTeamAdvisor.name : "Advisor";
    $[42] = activeEngagement;
    $[43] = isMyFoundersRoute;
    $[44] = lockedTeamAdvisor;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  const asideTitle = t14;
  const queryLoading = isMyFoundersRoute ? founderQuery.loading && founderEngagements.length === 0 : boardQuery.isInitialLoading && board.length === 0;
  const queryError = isMyFoundersRoute ? founderQuery.error : boardQuery.error;
  let t15;
  if ($[46] !== activeEngagement) {
    t15 = activeEngagement ? founderUserIdOf(activeEngagement) : null;
    $[46] = activeEngagement;
    $[47] = t15;
  } else {
    t15 = $[47];
  }
  const activeFounderUserId = t15;
  const activeAdvisorUserId = activeEngagement?.advisorUserId || activeEngagement?.advisorUser?.userId || null;
  let t16;
  if ($[48] !== activeContent || $[49] !== asideTitle) {
    t16 = () => {
      activeContent.setItem?.({
        id: "advisors-aside",
        title: asideTitle
      });
    };
    $[48] = activeContent;
    $[49] = asideTitle;
    $[50] = t16;
  } else {
    t16 = $[50];
  }
  let t17;
  if ($[51] !== activeContent.setItem || $[52] !== asideTitle) {
    t17 = [activeContent.setItem, asideTitle];
    $[51] = activeContent.setItem;
    $[52] = asideTitle;
    $[53] = t17;
  } else {
    t17 = $[53];
  }
  useEffect(t16, t17);
  let t18;
  if ($[54] !== activeAdvisorUserId || $[55] !== activeEngagement || $[56] !== activeFounderUserId || $[57] !== isMyFoundersRoute || $[58] !== isUpgradeRoute || $[59] !== lockedTeamAdvisor || $[60] !== queryLoading) {
    t18 = isMyFoundersRoute && activeEngagement ? <Box flex={1} height="full" minHeight={0} width="full"><EngagementAsidePanel key={activeFounderUserId || activeEngagement.id || "founder"} engagement={activeEngagement} profilePerspective="founder" /></Box> : activeEngagement ? <Box flex={1} height="full" minHeight={0} width="full"><EngagementAsidePanel key={activeAdvisorUserId || activeEngagement.id || "advisor"} engagement={activeEngagement} profilePerspective="advisor" /></Box> : lockedTeamAdvisor ? <Box flex={1} minHeight={0} overflowY="auto" width="full"><LockedTeamAdvisorMiniProfile key={lockedTeamAdvisor.navKey} advisor={lockedTeamAdvisor} /></Box> : queryLoading ? <Center paddingY={8} width="full"><Spinner size="sm" /></Center> : <Text color="colorPalette.fg/60" fontSize="sm" paddingY={8} textAlign="center" width="full">{isMyFoundersRoute ? "Select a founder from the sidebar to view their profile." : isUpgradeRoute ? "Select a Startups.com advisor from the sidebar to preview their profile." : "Select an advisor from the sidebar to view their profile."}</Text>;
    $[54] = activeAdvisorUserId;
    $[55] = activeEngagement;
    $[56] = activeFounderUserId;
    $[57] = isMyFoundersRoute;
    $[58] = isUpgradeRoute;
    $[59] = lockedTeamAdvisor;
    $[60] = queryLoading;
    $[61] = t18;
  } else {
    t18 = $[61];
  }
  let t19;
  if ($[62] !== queryError || $[63] !== queryLoading || $[64] !== t18) {
    t19 = <VStack align="stretch" gap={4} height="full" minHeight={0} overflow="hidden" padding={4} width="full"><Box display="flex" flex={1} flexDirection="column" minHeight={0} overflow="hidden" width="full"><AdvisorsQueryState error={queryError} loading={queryLoading}>{t18}</AdvisorsQueryState></Box></VStack>;
    $[62] = queryError;
    $[63] = queryLoading;
    $[64] = t18;
    $[65] = t19;
  } else {
    t19 = $[65];
  }
  return t19;
};
function _temp(engagement) {
  return !engagement.isAI;
}
function _temp2(engagement_0) {
  return engagement_0.isAI;
}